module.exports = {
  message: {
    login: "Login",
    Username: "Username",
    zh: "Chinese",
    en: "English",
    out_name: "WIN365",
    out_app_kind: "Giải trí",
    first: "Giải Trí Hàng Đầu",
    k_score: "K lượt đánh giá",
    install: "Tải về",
    install_free: "Tải App miễn phí",
    android_no_support: "Không hỗ trợ Android",
    start_download: "Bắt đầu tải",
    down_fail: "Tải không thành công",
    try_again: "Thử lại",
    installing: "Đang cài đặt",
    install_introduce: "Hướng dẫn cài đặt",
    appal_video_guild: "Video hướng dẫn cài đặt iOS APP\n",
    over: "Hoàn thành",
    open_in_itune: "Vui lòng mở liên kết trong itunes để cài đặt",
    intro: "Giới thiệu",
    out_intro:
      "WIN365 là một trong những tập đoàn ngành game hàng đầu trên thế giới. Có trụ sở chính tại Philippines, sở hữu giấy phép kinh doanh hợp pháp PAGCOR , điều hành nhiều thương hiệu casino và phương tiện giải trí thể thao, đồng thời phạm vi kinh doanh bao phủ khắp thế giới. Tập đoàn của chúng tôi với các nhà quản lý với hơn 10 năm kinh nghiệm trong ngành công nghiệp game và hơn 2000 nhân viên phục vụ chuyên nghiệp, thúc đẩy mạnh mẽ hợp tác chiến lược thể thao cạnh tranh, giám sát chặt chẽ và sàng lọc tất cả các loại trò chơi để đảm bảo tính công bằng.Tất cả các trò chơi và sản phẩm của tập đoàn đều đã trải qua nhiều cuộc kiểm tra và đánh giá để đảm bảo tỷ lệ cược và thanh toán chính xác, đồng thời cung cấp cho người dùng trải nghiệm chơi game công bằng và chất lượng dịch vụ tốt nhất.",
    score_and_post: "Xếp hạng & Đánh giá",
    fullscore: "Tối đa 5",
    new_fun: "Chức năng mới",
    out_new_feature: "",
    info: "Thông Tin",
    out_distributor: "Win365",
    distributor: "Nhà cung cấp",
    size: "Kích cỡ",
    kind: "Danh mục",
    need_ios_compatible: "Phiên bản iOS 9.0 trở lên, tương thích với iPhone",
    compatible: "Tương thích",
    out_langs: "Tiếng Trung,Tiếng Anh,Tiếng Nhật,Tiếng Việt,Tiếng Thái",
    lang: "Ngôn ngữ",
    age_limit: "Phân chia độ tuổi",
    age: "Tuổi",
    out_copyright: "",
    copyright: "Bản quyền",
    out_app_price: "Miễn phí",
    price: "Giá",
    policy_privay: "Chính sách bảo mật",
    randomCode: "Xác định duy nhất",
    under18: "Giới hạn từ 18 tuổi trở lên",
    disclaimer: "Tuyên bố miễn trừ trách nhiệm",
    disclaimer_detail:
      "Trang web này chỉ cung cấp cho nhà phát triển dịch vụ lưu trữ cài đặt và tải xuống ứng dụng. Nội dung và các vấn đề vận hành liên quan được chịu trách nhiệm bởi nhà phát triển ứng dụng và không liên quan đến trang web này.",
    step1: "Bước 1",
    click_coner: "Nhấp vào góc trên bên phải",
    button: "Nút",
    step2: "Bước 2",
    open_IE: "Nhập và mở trong trình duyệt safari",
    click_copy: 'Nhấp "Sao chép" liên kết',
    outof_limit:
      "Đã đạt giới hạn tải trong ngày, vui lòng thử lại vào ngày mai!",
    back_detail: "Vui lòng quay lại màn hình để xem chi tiết",
    desc: "Hồ sơ cấu hình",
    desc_why_install: "Hồ sơ cấu hình là gì? Tại sao phải cài đặt?",
    desc_reson:
      'Hồ sơ cấu hình được công ty Apple chứng nhận, dùng để ghi lại thiết bị khách hàng, hãy yên tâm sử dụng. Hồ sơ cấu hình để đăng ký thiết bị của Quý khách đến hệ thống khách hàng của Apple, đây là điều kiện tiên quyết để cài đặt "Hỗ trợ cài đặt APP" của Apple.',
    desc_explain_title:
      "Trong quá trình cài đặt bị gián đoạn tại trang cài đặt, phải xử lý như thế nào?",
    desc_explain_desc:
      "Quá trình tải bị ngưng là lỗi của hệ thống iOS, phương án giải quyết: Về lại màn hình chính - vuốt lên - đóng trang cài đặt - cài đặt lại.",
    desc_why_password:
      " Tại sao phải nhập mật khẩu khi cài đặt hồ sơ cấu hình? Và nhập mật khẩu nào?",
    desc_psw_reson:
      'Để chắc chắn rằng chủ thiết bị đang thao tác, cài hồ sơ cấu hình cần nhập "Mật khẩu mở khóa"',
    desc_know: "OK",
    guild_title_1: "Cách bật chế độ nhà phát triển trong IOS16?",
    guild_title: "Hồ sơ cấu hình là gì?",
    guild: "Hướng dẫn cài đặt",
    guild_step1: "Bước 1: Cho phép mở cài đặt hồ sơ cấu hình",
    guild_step2: 'Bước 2: Nhấp nút "Cài đặt" trên góc phải',
    guild_step3: "Bước 3: Nhập mật khẩu mở khóa điện thoại",
    guild_step4: 'Bước 4: Nhấp vào nút "Cài đặt" bên dưới',
    error1: "Lỗi mạng, vui lòng liên hệ Hỗ trợ trực tuyến\n",
    ageleft: "Giới hạn từ ",
    ageright: " tuổi trở lên",
    versionleft: "Phiên bản iOS ",
    versionright: " trở lên, tương thích với iPhone",
    to_main_site: "đăng nhập web",
    release_time: "ngày phát hành",
    previous_version: "phiên bản trước",
    version_info: "Thông tin phiên bản",
    ios16Tip1:
      "Đối với ios16 trở lên, vui lòng bật chế độ nhà phát triển trước",
    ios16Tip2:
      "“Cài đặt->Quyền riêng tư và bảo mật->Chế độ nhà phát triển->Bật”"
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/vn.js